var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dd-icon',{staticStyle:{"margin-left":"-4px"},attrs:{"icon":_vm.iconByDocument,"size":"md"}})}
var staticRenderFns = []

export { render, staticRenderFns }